export default __webpack_public_path__ + "static/media/calendar.98586a02.svg";